import { defineStore } from 'pinia'
import { useApiClient } from '~/composables/api/api'

type OptionItem = {
  value: number
  label: string
}

type FormOptionset = {
  attributeDisplayName: string
  webPortalApiReference: string
  apiModelAttributeName: string
  options: OptionItem[]
}

export const useGlobalDataSourcesStore = defineStore('global-data-sources', () => {
  const formOptionsets = ref<FormOptionset[]>([])
  const isLoadingFormOptionsets = ref(false)
  const hasLoadedFormOptionsets = ref(false)

  const loadFormOptionsets = async ({ force = false }: { force?: boolean } = {}) => {
    if (isLoadingFormOptionsets.value) return
    if (hasLoadedFormOptionsets.value && !force) return

    isLoadingFormOptionsets.value = true
    try {
      const response = await useApiClient<FormOptionset[]>('/public/proxy/webportal-optionsets', {
        method: 'GET',
      })
      formOptionsets.value = response
      hasLoadedFormOptionsets.value = true
    } finally {
      isLoadingFormOptionsets.value = false
    }
  }

  const getOptionsByAttributeName = (attributeName: string) => {
    return (
      formOptionsets.value.find((option) => option.apiModelAttributeName === attributeName)
        ?.options ?? []
    )
  }

  return {
    formOptionsets,
    isLoadingFormOptionsets,
    hasLoadedFormOptionsets,
    loadFormOptionsets,
    getOptionsByAttributeName,
  }
})
